import getBasePath from '../../../../common/functions/api-resource';

const basePath = getBasePath('workflow_tatico', 'execucao/planejamento-tatico');

const workflowPlanejamento = {
  statusPasso: { method: 'GET', url: `${basePath}/{idPlanejamento}/passos/status` },
};

export default resource => resource(`${basePath}`, {}, workflowPlanejamento);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/workflow-planejamento.js